export enum CURRENCY_CODE {
  USD = 'USD',
  GBP = 'GBP',
}

/**
 * Returns the currency symbol for a given ISO 4217 currency code.
 * Defaults to '$' if the currency code is invalid or not provided.
 */
export const getCurrencySymbol = (currencyCode?: string): string => {
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode || 'USD' })
      .formatToParts(0)
      .find((part) => part.type === 'currency')!.value;
  } catch {
    return '$';
  }
};
